import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { ClearCurrentCsa, ClearCurrentMcp, LoadCurrentMcp, LoadCurrentMcpSuccess, McpActionTypes, McpUpdate } from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentMcpId, getCurrentProject } from '@completion/selectors';
import { McpService } from '@completion/services';
import { NotificationService } from '../../services/notification.service';
import { McPackage, Project } from '@completion/models';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class McpEffect {
  constructor(
    private actions$: Actions,
    private mcpService: McpService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  clearCurrentMcp$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearCurrentMcp>(McpActionTypes.ClearCurrentMcp),
      map(() => new ClearCurrentCsa()),
    ),
  );

  loadMcp$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LoadCurrentMcp>(McpActionTypes.LoadCurrentMcp),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>, this.store.select(getCurrentMcpId) as Observable<number>),
      filter(([_, currentProject, mcpId]) => !!(currentProject && mcpId)),
      trackResource<McPackage>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.mcpService,
        method: 'getMcp',
        serviceArgs: ([_, currentProject, mcpId]) => [currentProject.id, mcpId],
        onSuccess: (response) => new LoadCurrentMcpSuccess(response),
      }),
    ),
  );

  updateMcp$ = createEffect(() =>
    this.actions$.pipe(
      ofType<McpUpdate>(McpActionTypes.McpUpdate),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource<McPackage>({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.mcpService,
        method: 'updateMcp',
        serviceArgs: ([action, currentProject]) => [currentProject.id, action.mcp],
        onSuccess: (response) => new LoadCurrentMcpSuccess(response),
      }),
    ),
  );
}
